import Vue from 'vue';
import VueRouter from 'vue-router';
import Main from '../views/Main.vue';
import Images from '../views/Images.vue';
import Login from '../views/Login.vue';
import Marketplace from '../views/Images/Marketplace.vue';
import { createSandbox } from 'vue-kindergarten';
import RouteGoverness from '../governesses/RouteGoverness';
import basePerimeter from '../perimeters/base';
import store from '../store';
import child from '../child';
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'main',
    component: Main,
    meta: {
      perimeter: basePerimeter,
      perimeterAction: 'watch',
    }
  },
  {
    path: '/images',
    name: 'images',
    component: Images,
    meta: {
      perimeter: basePerimeter,
      perimeterAction: 'watch',
    },
    children: [
      {
        path: ':id',
        component: Marketplace,
      },
    ],
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  to.matched.some((routeRecord) => {
    const perimeter = routeRecord.meta.perimeter;
    const Governess = routeRecord.meta.governess || RouteGoverness;
    const action = routeRecord.meta.perimeterAction || 'route';

    if (perimeter) {
      try {
        const sandbox = createSandbox(child(store), {
          governess: new Governess(),
          perimeters: [
            perimeter,
          ],
        });

        return sandbox.guard(action, { to, from, next });
      } catch (err) {
        console.log(err)
      }
    }

    return next()
  })
})

export default router
